import React from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import { DynamicObjectListField, SectionTitle, SeparatorBar, TextField } from "../../../components";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  gameInfoSupplementaryDataInitialValues,
  useIdXboxGameInformationSupplementaryDataValidationSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { getIsSavingForm } from "../../../redux/selectors";
import { GameInformationFormId, GameInformationSubFormsId } from "../GameInformationPageConstants";
import * as styles from "./SupplementaryDataSubForm.module.css";

const SupplementaryDataSubForm = (props: SubFormNavigationProps) => {
  const [
    developmentStudioExperience,
    listTheMostRecentTitleCredits,
    titlesPreviouslyShippedByYourStudio,
    titlesPreviouslyShippedByYourTeamMembers,
    competitorTitles,
    competitorTitlesSubtitle,
    platform,
    gameTitle,
    yearShipped,
    teamMemberName,
    addTitle,
    addCompetitorTitle,
  ] = useStrings(
    "developmentStudioExperience",
    "listTheMostRecentTitleCredits",
    "titlesPreviouslyShippedByYourStudio",
    "titlesPreviouslyShippedByYourTeamMembers",
    "competitorTitles",
    "competitorTitlesSubtitle",
    "platform",
    "gameTitle",
    "yearShipped",
    "teamMemberName",
    "addTitle",
    "addCompetitorTitle"
  );
  const validationSchema = useIdXboxGameInformationSupplementaryDataValidationSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={gameInfoSupplementaryDataInitialValues}
      formId={GameInformationFormId}
      subFormId={GameInformationSubFormsId.SupplementaryData}
      {...props}
    >
      <SectionTitle title={developmentStudioExperience} subtitle={listTheMostRecentTitleCredits} />
      <div className={styles.dynamicContainer}>
        <DynamicObjectListField
          hasLabels={true}
          name="devStudioExperience"
          title={titlesPreviouslyShippedByYourStudio}
          buttonLabel={addTitle}
          disabled={isSavingFormToCrm}
          renderChild={(name: string, index: number) => (
            <Row className={styles.contentRow}>
              <Column className={styles.field}>
                <TextField
                  name={`${name}.${index}.platform`}
                  title={platform}
                  isSaving={isSavingFormToCrm}
                  onlyInternalElements={true}
                />
              </Column>
              <Column className={styles.field}>
                <TextField
                  name={`${name}.${index}.gameTitle`}
                  title={gameTitle}
                  isSaving={isSavingFormToCrm}
                  onlyInternalElements={true}
                />
              </Column>
              <Column className={styles.field}>
                <TextField
                  name={`${name}.${index}.yearShipped`}
                  title={yearShipped}
                  isSaving={isSavingFormToCrm}
                  onlyInternalElements={true}
                />
              </Column>
            </Row>
          )}
        />
        <SeparatorBar />
        <DynamicObjectListField
          hasLabels={true}
          name="teamMembersPreviousTitles"
          title={titlesPreviouslyShippedByYourTeamMembers}
          buttonLabel={addTitle}
          disabled={isSavingFormToCrm}
          renderChild={(name: string, index: number) => (
            <Row className={styles.contentRow}>
              <Column>
                <Row>
                  <Column className={styles.field}>
                    <TextField
                      name={`${name}.${index}.memberName`}
                      title={teamMemberName}
                      isSaving={isSavingFormToCrm}
                      onlyInternalElements={true}
                    />
                  </Column>
                  <Column className={styles.field}>
                    <TextField
                      name={`${name}.${index}.gameTitle`}
                      title={gameTitle}
                      isSaving={isSavingFormToCrm}
                      onlyInternalElements={true}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column className={styles.field}>
                    <TextField
                      name={`${name}.${index}.platform`}
                      title={platform}
                      isSaving={isSavingFormToCrm}
                      onlyInternalElements={true}
                    />
                  </Column>
                  <Column className={styles.field}>
                    <TextField
                      name={`${name}.${index}.yearShipped`}
                      title={yearShipped}
                      isSaving={isSavingFormToCrm}
                      onlyInternalElements={true}
                    />
                  </Column>
                </Row>
              </Column>
            </Row>
          )}
        />
        <SeparatorBar />
        <DynamicObjectListField
          hasLabels={true}
          name="competitorTitles"
          title={competitorTitles}
          subtitle={competitorTitlesSubtitle}
          buttonLabel={addCompetitorTitle}
          disabled={isSavingFormToCrm}
          renderChild={(name: string, index: number) => (
            <Row className={styles.contentRow}>
              <Column className={styles.field}>
                <TextField
                  name={`${name}.${index}.platform`}
                  title={platform}
                  isSaving={isSavingFormToCrm}
                  onlyInternalElements={true}
                />
              </Column>
              <Column className={styles.field}>
                <TextField
                  name={`${name}.${index}.gameTitle`}
                  title={gameTitle}
                  isSaving={isSavingFormToCrm}
                  onlyInternalElements={true}
                />
              </Column>
            </Row>
          )}
        />
      </div>
    </SubForm>
  );
};

export default SupplementaryDataSubForm;
